import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import StudentsList from '../../components/users/tabs/userslist';
import ManageCompanies from '../../components/users/tabs/companiesManager';
import DeleteVacancy from '../../components/users/tabs/deleteVacancy';
import LoadUserApplications from '../../components/users/modal/loadApplications';
import { palette } from '../../system/styles/styles';

const MainContainer = styled.main`
  padding: 0px;
  margin: 0px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  font-family: 'Sofia Pro', sans-serif;
  align-items: center;
  .adminUsersNavBar {
    width: 90%;
    display: flex;
    padding: 10px;
    align-items: flex-start;
    justify-content: flex-start;
    background-color: #fff;
    box-shadow: 0px 2px 30px #00000029;
    margin-top: 8px;
    border-radius: 8px;
  }
  .navItemActive {
    width: 33.33%;
    padding: 10px;
    font-size: 1.6rem;
    text-align: center;
    margin: 0px;
    background-color: ${(props) => (props.adminColor ? props.adminColor : '#0f3f44')};
    color: #fff;
    cursor: pointer;
    height: 100%;
    border-radius: 8px;
    font-weight: 600;
    line-height: 32px;
  }
  .navItem {
    width: 33.33%;
    padding: 10px;
    font-size: 1.6rem;
    color: ${(props) => (props.adminColor ? props.adminColor : '#0f3f44')};
    text-align: center;
    margin: 0px;
    cursor: pointer;
    height: 100%;
    border-radius: 8px;
    font-weight: 600;
    line-height: 32px;
  }
  .adminUsersPage {
    width: 90%;
    margin-top: 40px;
    margin-bottom: 50px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;
    background-color: ${palette.white};
    border-radius: 8px;
    padding: 35px;
  }
`;

const MainDashboard = () => {
  const { platform } = useSelector((state) => state);

  const [state, setState] = useState({
    CurrentTable: 1,
    loadUserApplications: false,
    user: {},
  });

  const SubNavigation = (p) => {
    setState((prevState) => ({
      ...prevState,
      CurrentTable: p,
    }));
  };

  const capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleModal = (open, id) => {
    setState((prevState) => ({
      ...prevState,
      loadUserApplications: open,
      user: id,
    }));
  };

  return (
    <MainContainer adminColor={platform?.adminColor}>
      <div className="adminUsersNavBar">
        <p className={state.CurrentTable === 1 ? 'navItemActive' : 'navItem'} onClick={() => SubNavigation(1)}>
          Empresas
        </p>
        <p className={state.CurrentTable === 2 ? 'navItemActive' : 'navItem'} onClick={() => SubNavigation(2)}>
          {capitalize(platform.userTypeText)}
        </p>
        <p className={state.CurrentTable === 3 ? 'navItemActive' : 'navItem'} onClick={() => SubNavigation(3)}>
          Vacantes
        </p>
      </div>
      {state.CurrentTable === 1 ? (
        <div className="adminUsersPage">
          <ManageCompanies />
        </div>
      ) : null}
      {state.CurrentTable === 2 ? (
        <div className="adminUsersPage">
          <StudentsList handleModal={handleModal} />
        </div>
      ) : null}
      {state.CurrentTable === 3 ? (
        <div style={{ width: '100%' }}>
          <DeleteVacancy />
        </div>
      ) : null}
      <LoadUserApplications open={state.loadUserApplications} user={state.user} handleModal={handleModal} />
    </MainContainer>
  );
};

export default MainDashboard;
